<template>
    <div class="wrapper">
      <div class="topo-header centro">
        <botao-voltar nomeRota="CargoColegiado" />
        <h1>{{ cargoColegiadoForm.id ? "Editar" : "Novo" }} Cargo</h1>
      </div>
      <div class="tab-dados-basicos">
        <div class="form centro">
          <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
          <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
          <form @submit.prevent="enviarForm">
            <div class="caixa-form">
                <div class="flexbox">
                    <div class="item">
                        <label><b>{{ possuiAsterisco("Nome do Cargo:") }}</b></label>
                        <input type="text" placeholder="Digite o nome" v-model="cargoColegiadoForm.nome" :disabled="salvando" />
                    </div>
                </div>
            </div>
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit" :disabled="salvando">
                <img id="spinner-loading" class="spinner-loading" src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento" :style="salvando ? 'visibility: visible; position: relative;' : 'visibility: hidden; position: absolute;'">
                <p id="conteudo-botao" v-if="!salvando">{{ cargoColegiadoForm.id ? "Atualizar" : "Criar" }}</p>
                <p v-else>Carregando...</p>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
  
<script>
  import CargoColegiadoApi from "../../services/CargoColegiadoApi";
  import BotaoVoltar from '../../components/BotaoVoltar.vue';
  import MsgErroFormularios from '../MsgErroFormularios';
  
  export default {
    name: 'CargoColegiadoForm',
    props: {
      cargoColegiado: {
        type: Object,
        required: false,
      },
      nomeRota: String,
    },
    data() {
      return {
        salvando: false,
        erro: false,
        msgErros: {
          nome: '',
          default: '',
        },
        cargoColegiadoForm: this.cargoColegiado 
        ? {
            id: this.cargoColegiado.id,
            nome: this.cargoColegiado.nome,
        }
        : {
            id: null,
            nome: null,
        }
      };
    },
    components: {
      BotaoVoltar,
      MsgErroFormularios,
    },
    created() {
        this.cargoColegiadoApi = new CargoColegiadoApi();
    },
    methods: {
      async enviarForm() {
        try {
          const flag = this.validarForm(this.cargoColegiadoForm);
          if (flag === 1) {
            this.erro = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
  
          this.salvando = true;
          this.erro = false;
          this.msgErros = { nome: '', default: '' };

          if (this.cargoColegiadoApi.cancelTokens.setCargoColegiado) {
              this.cargoColegiadoApi.cancelTokens.setCargoColegiado.cancel();
          }

          const data = await this.cargoColegiadoApi.setCargoColegiado(this.cargoColegiadoForm); 
  
          var rota = this.$router;
          setTimeout(function () {
              rota.push({
                  name: "CargoColegiadoShow",
                  params: {
                      id: data.id,
                  },
              });
          }, 1000);
        } catch (err) {
          if (this.cargoColegiadoApi.isCancel(err)) {
              return;
          }
          console.error('Erro ao enviar formulário:', err);
          this.salvando = false;
          this.erro = true;
          const { response } = err;
          if (response && response.data) {
            this.msgErros = response.data;
          } else {
            this.msgErros.default = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
          }
        }
      },
      validarForm(cargoColegiadoForm) {
        let flag = 0;
        this.msgErros = {
          nome: '',
          default: '',
        };
  
        if (!cargoColegiadoForm.nome || cargoColegiadoForm.nome.trim() === '') {
            this.msgErros.nome = 'O campo nome não foi preenchido.';
            flag = 1;
        }

        return flag;
      },
      possuiAsterisco(texto) {
        return '* ' + texto;
      },
      fecharErro() {
        this.erro = false;
      },
    },
  };
</script>
  
  
<style lang="scss" scoped>

@import "../../styles/catalogoForm.scss";

.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
</style>
